import { ButtonTypeEnum } from '@/modules/core/models/enums'

export default class ModalButton {
  private _text: string
  private _navTo?: string | null
  private _callback?: (() => void) | null
  private _type?: string
  private _onclick?: (() => void) | null
  private _icon?: string

  constructor(data: Partial<ModalButton> = {}) {
    this._text = data.text ?? ''
    this._navTo = data?.navTo ?? null
    this._type = data?.type ?? ButtonTypeEnum.PRIMARY
    this._callback = data?.callback ?? null
    this._onclick = data?.onclick ?? null
    this._icon = data?.icon
  }

  get text(): string {
    return this._text
  }

  get navTo(): string | null {
    return this._navTo ?? null
  }

  get type(): string {
    return this._type ?? ButtonTypeEnum.PRIMARY
  }

  get callback(): (() => void) | null {
    return this._callback ?? null
  }

  get onclick(): (() => void) | null {
    return this._onclick ?? null
  }

  get icon(): string | undefined {
    return this._icon
  }

  runCallback() {
    this.callback?.()
  }
}
